export default function TOC({ items }) {
  return (
    <nav
      aria-label="Sommaire"
      className="hidden xl:block sticky top-6 p-4 rounded-2xl border border-slate-200 dark:border-slate-800 bg-white/70 dark:bg-slate-900/50 backdrop-blur"
    >
      <p className="text-xs uppercase tracking-wide text-slate-500 dark:text-slate-400 mb-2">
        Sommaire
      </p>
      <ul className="space-y-2">
        {items.map((s) => (
          <li key={s.id}>
            <a
              href={`#${s.id}`}
              className="text-sm text-slate-700 dark:text-slate-200 hover:underline"
            >
              {s.label}
            </a>
          </li>
        ))}
      </ul>
    </nav>
  );
}
